import { render, staticRenderFns } from "./valoraciones.vue?vue&type=template&id=525ac3d7&scoped=true"
import script from "./valoraciones.vue?vue&type=script&lang=js"
export * from "./valoraciones.vue?vue&type=script&lang=js"
import style0 from "./valoraciones.vue?vue&type=style&index=0&id=525ac3d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525ac3d7",
  null
  
)

export default component.exports